type prams = {
  url: string;
  fileName?: string;
};

const downloadFile = ({ url, fileName = "" }: prams): void => {
  let a = document.createElement("a");
  a.href = url;
  a.setAttribute("download", fileName);
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export default downloadFile;
